import React, { Fragment } from 'react';
import { Dialog } from './../../common/dialog';
import numeral from 'numeral';
import { dateToTimezone, empty } from './../../../utils';

const InfoModal = React.memo((props) => {
    const hideHandler = () => {
        props.setIdModal(null);
        props.hideInfoModal();
    };

    let selectedOrder = null;
    for (const order of props.orders) {
        if (parseInt(order.id) === parseInt(props.idModal)) {
            selectedOrder = order;
            break;
        }
    }

    let status = '';
    if (selectedOrder && parseInt(selectedOrder.status) === 1) {
        status = 'Pending';
    } else if (selectedOrder && parseInt(selectedOrder.status) === 2) {
        status = 'Approved';
    } else if (selectedOrder && parseInt(selectedOrder.status) === 3) {
        status = 'Rejected';
    }

    let cardFor = 'N/A';
    let quantity = selectedOrder ? numeral(selectedOrder.quantity).format('0,0') : '';
    let piecesPer = null;
    if (selectedOrder && selectedOrder.variables !== '') {
        let json = JSON.parse(selectedOrder.variables);
        if (json.name && json.name !== '') {
            cardFor = json.name;
        }

        if (json.staticTemplateCode) {
            quantity += (selectedOrder.quantity > 1 ? ' bundles' : ' bundle');
            quantity += ' (' + numeral(selectedOrder.pieces_per * selectedOrder.quantity).format('0,0') + ' pieces)';
            piecesPer = <div><b>Pieces per Bundle:</b> {numeral(selectedOrder.pieces_per).format('0,0')}</div>

            if (parseInt(json['staticTemplateCode']) === 647) {
                quantity = selectedOrder.quantity;
                piecesPer = null;
            } else if (parseInt(json['staticTemplateCode']) === 652) {
                quantity = selectedOrder.quantity;
                piecesPer = null;
            }
        }

        if (json.promotionalTemplateCode && parseInt(selectedOrder.is_bundles)) {
            quantity += (selectedOrder.quantity > 1 ? ' bundles' : ' bundle');
            quantity += ' (' + numeral(selectedOrder.pieces_per * selectedOrder.quantity).format('0,0') + ' pieces)';
            piecesPer = <div><b>Pieces per Bundle:</b> {numeral(selectedOrder.pieces_per).format('0,0')}</div>
        }
    }

    if (selectedOrder && selectedOrder.product_type === 'Brochures & Flyers') {
        const variables = JSON.parse(selectedOrder['variables']);
        if (parseInt(variables['brochureTemplateCode']) === 1) {
            quantity = numeral(selectedOrder.quantity).format('0,0') + (selectedOrder.quantity > 1 ? ' bundles' : ' bundle');
            quantity += ' (' + numeral(250 * selectedOrder.quantity).format('0,0') + ' pieces)';
            piecesPer = <div><b>Pieces per Bundle:</b> 250</div>
        } else if (parseInt(variables['brochureTemplateCode']) === 2) {
            quantity = numeral(selectedOrder.quantity).format('0,0');
        } else if (parseInt(variables['brochureTemplateCode']) === 8) {
            quantity = numeral(selectedOrder.quantity).format('0,0') + (selectedOrder.quantity > 1 ? ' bundles' : ' bundle');
            quantity += ' (' + numeral(50 * selectedOrder.quantity).format('0,0') + ' pieces)';
            piecesPer = <div><b>Pieces per Bundle:</b> 50</div>
        }
    }

    let quantityRow = <div><b>Quantity:</b> {quantity}</div>;

    let orderedBy = null;
    if (selectedOrder) {
        orderedBy = selectedOrder.user_name;
        if (selectedOrder.cxmlPunchout != null) {
            const extrinsicData = JSON.parse(selectedOrder.cxmlPunchout.extrinsic);
            let nameParts = [];
            if (extrinsicData.FirstName) {
                nameParts.push(extrinsicData.FirstName);
            }
            if (extrinsicData.LastName) {
                nameParts.push(extrinsicData.LastName);
            }
            orderedBy = nameParts.join(' ');
            if (orderedBy === '') {
                orderedBy = 'Coupa';
            }
        }
    }

    let actionByRow = null;
    if (selectedOrder && parseInt(selectedOrder.status) === 2) {
        actionByRow = <div><b>Approved By:</b> {selectedOrder.approval_rejected_by_name}</div>;
    } else if (selectedOrder && parseInt(selectedOrder.status) === 3) {
        actionByRow = <div><b>Rejected By:</b> {selectedOrder.approval_rejected_by_name}</div>;
    }

    const generatePrintReadyFile = (event) => {
        event.preventDefault();
        props.generatePrintReadyFile(selectedOrder.id);
    };

    let pdfUrl = null;
    if (selectedOrder) {
        pdfUrl = <a href={selectedOrder.pdf_url} target="_blank" rel="noopener noreferrer">{selectedOrder.pdf_url}</a>;
        if (!empty(selectedOrder.final_pdf_url)) {
            pdfUrl = <a href={selectedOrder.final_pdf_url} target="_blank" rel="noopener noreferrer">{selectedOrder.final_pdf_url}</a>;
        }
    }

    let pdfUrlRow = <div><b>PDF URL:</b> {pdfUrl}</div>;

    if (selectedOrder) {
        const variables = JSON.parse(selectedOrder['variables']);
        if (props.user && ![3, 7].includes(parseInt(props.user.uth_type)) && variables['templateCode'] === 'p17t3') {
            pdfUrlRow = <div><b>Preview URL:</b> <a href={selectedOrder.preview_url} target="_blank" rel="noopener noreferrer">{selectedOrder.preview_url}</a></div>;
        }
    }

    if (selectedOrder && selectedOrder.product_type === 'Apparel') {
        pdfUrlRow = null;
    }
    if (selectedOrder && selectedOrder.product_type === 'MyUTHealth') {
        pdfUrlRow = <div><b>Preview URL:</b> <a href={selectedOrder.preview_url} target="_blank" rel="noopener noreferrer">{selectedOrder.preview_url}</a></div>;

        if (props.user && [3, 7].includes(parseInt(props.user.uth_type))) {
            const variables = JSON.parse(selectedOrder.variables);
            if ([1, 2, 3, 4, 10, 12, 13].includes(parseInt(variables['myuthealthTemplateCode']))) {
                pdfUrlRow = <div><b>PDF URL:</b> <a href={selectedOrder.pdf_url} target="_blank" rel="noopener noreferrer">{selectedOrder.pdf_url}</a></div>;
            } else if (parseInt(variables['myuthealthTemplateCode']) === 11) {
                if (variables['language'] === 'English') {
                    let url = 'https://ac-ut-health.s3.amazonaws.com/myuthealth-images/UTPM-9045_MyUTHealth+Parent_Guardian+Brochure-English-Print-bleed.pdf';
                    pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
                } else if (variables['language'] === 'Spanish') {
                    let url = 'https://ac-ut-health.s3.amazonaws.com/myuthealth-images/UTPM-9045_MyUTHealth+Parent_Guardian+Brochure-Spanish-Print-bleed.pdf';
                    pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
                } else if (variables['language'] === 'Vietnamese') {
                    let url = 'https://ac-ut-health.s3.amazonaws.com/myuthealth-images/UTPM-9045_MyUTHealth+Parent_Guardian+Brochure-Vietnames-Print-bleed.pdf';
                    pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
                } else if (variables['language'] === 'Chinese') {
                    let url = 'https://ac-ut-health.s3.amazonaws.com/myuthealth-images/UTPM-9045_MyUTHealth+ParentGuardian+Brochure-Chinese-Print-bleed.pdf';
                    pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
                } else if (variables['language'] === 'Arabic') {
                    let url = 'https://ac-ut-health.s3.amazonaws.com/myuthealth-images/UTPM-9045_MyUTHealth+ParentGuardian+Brochure-Arabic-Print-bleed.pdf';
                    pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
                }
            }
        }
    }
    if (selectedOrder && selectedOrder.product_type === 'Brochures & Flyers') {
        pdfUrlRow = <div><b>Preview URL:</b> <a href={selectedOrder.pdf_url} target="_blank" rel="noopener noreferrer">{selectedOrder.pdf_url}</a></div>;

        if (props.user && [3, 7].includes(parseInt(props.user.uth_type))) {
            const variables = JSON.parse(selectedOrder.variables);
            if (parseInt(variables['brochureTemplateCode']) === 3) {
                let url = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/645619_UTP-1001CO-PR_R-English.pdf';
                pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            } else if (parseInt(variables['brochureTemplateCode']) === 4) {
                let url = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/645619_UTP-1001CO-PR_R-Spanish.pdf';
                pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            } else if (parseInt(variables['brochureTemplateCode']) === 5) {
                let url = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/645619_UTP-1003CO-ComplaintsHMONotice-English-Spanish.pdf';
                pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            } else if (parseInt(variables['brochureTemplateCode']) === 6) {
                let url = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/645619_UTP-Translation-Services-Poster.pdf';
                pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            } else if (parseInt(variables['brochureTemplateCode']) === 8) {
                let url = 'https://ac-ut-health.s3.amazonaws.com/brochures-images/Purple_Art_Exhibit_Pamphlet_Trifold_Brochure-print-file.pdf';
                pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            } else if (parseInt(variables['brochureTemplateCode']) === 9) {
                let url = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/No_Surprise_Billing_with_bleed_12x18-final.pdf';
                pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            } else if (parseInt(variables['brochureTemplateCode']) === 10) {
                let url = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/UT_Good_Faith_Estimate_Notice_w_qr_codes.pdf';
                pdfUrlRow = <div><b>Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            } else if (parseInt(variables['brochureTemplateCode']) === 12) {
                if (empty(selectedOrder.final_pdf_url)) {
                    if (props.generatingPrintReadyFile) {
                        pdfUrlRow = <div><b>PDF URL:</b> Creating File... <i className="fas fa-circle-notch fa-spin" /></div>;
                    } else {
                        pdfUrlRow = <div><b>PDF URL:</b> <a href="/" onClick={generatePrintReadyFile}>Click here to generate the Print Ready file</a></div>;
                    }
                } else {
                    pdfUrlRow = <div><b>PDF URL:</b> <a href={selectedOrder.final_pdf_url} target="_blank" rel="noopener noreferrer">{selectedOrder.final_pdf_url}</a></div>;
                }
            }
        }
    }
    if (selectedOrder && selectedOrder.product_type === 'NRC') {
        pdfUrlRow = <div><b>Preview URL:</b> <a href={selectedOrder.pdf_url} target="_blank" rel="noopener noreferrer">{selectedOrder.pdf_url}</a></div>;
    }
    if (selectedOrder && selectedOrder.product_type === 'Holiday') {
        let variables = JSON.parse(selectedOrder.variables);

        let quantity1 = null;
        let quantity2 = null;
        let quantity3 = null;
        if (props.user && (parseInt(props.user.uth_type) === 3 || parseInt(props.user.uth_type) === 7)) {
            let card1Url = null;
            if (parseInt(variables.quantity1) > 0) {
                quantity1 = <div><b>Card 1 Quantity:</b> {variables.quantity1}</div>;
                let url = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/static-files/printready-holiday-card-1_211124.pdf';
                card1Url = <div><b>Card 1 URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            }

            let card2Url = null;
            if (parseInt(variables.quantity2) > 0) {
                quantity2 = <div><b>Card 2 Quantity:</b> {variables.quantity2}</div>;
                let url = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/static-files/printready-holiday-card-2-211124.pdf';
                card2Url = <div><b>Card 2 URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            }

            let card3Url = null;
            if (parseInt(variables.quantity3) > 0) {
                quantity3 = <div><b>Card 3 Quantity:</b> {variables.quantity3}</div>;
                let url = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/static-files/printready-holiday-card-3-211124.pdf';
                card3Url = <div><b>Card 3 URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            }

            let envelopeUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/static-files/printready-holiday-envelope-211124.pdf';
            pdfUrlRow = (
                <Fragment>
                    {card1Url}
                    {card2Url}
                    {card3Url}
                    <div><b>Envelope URL:</b> <a href={envelopeUrl} target="_blank" rel="noopener noreferrer">{envelopeUrl}</a></div>
                </Fragment>
            );
        } else {
            let card1Url = null;
            if (parseInt(variables.quantity1) > 0) {
                quantity1 = <div><b>Card 1 Quantity:</b> {variables.quantity1}</div>;
                let url = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/static-images/printready-holiday-card-1-211124.jpg';
                card1Url = <div><b>Card 1 Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            }

            let card2Url = null;
            if (parseInt(variables.quantity2) > 0) {
                quantity2 = <div><b>Card 2 Quantity:</b> {variables.quantity2}</div>;
                let url = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/static-images/printready-holiday-card-2-211124.jpg';
                card2Url = <div><b>Card 2 Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            }

            let card3Url = null;
            if (parseInt(variables.quantity3) > 0) {
                quantity3 = <div><b>Card 3 Quantity:</b> {variables.quantity3}</div>;
                let url = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/static-images/printready-holiday-card-3-211124.jpg';
                card3Url = <div><b>Card 3 Preview URL:</b> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></div>;
            }

            let envelopeUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/static-images/printready-holiday-envelope-211124.jpg';
            pdfUrlRow = (
                <Fragment>
                    {card1Url}
                    {card2Url}
                    {card3Url}
                    <div><b>Envelope Preview URL:</b> <a href={envelopeUrl} target="_blank" rel="noopener noreferrer">{envelopeUrl}</a></div>
                </Fragment>
            );
        }

        quantityRow = (
            <Fragment>
                {quantity1}
                {quantity2}
                {quantity3}
            </Fragment>
        );
    }

    if (selectedOrder && selectedOrder.product_type === 'Notepads') {
        let variables = JSON.parse(selectedOrder.variables);
        if (variables['templateCode'] === 'p18t2') {
            quantityRow = <div><b>Quantity:</b> {quantity} pad(s)</div>;
        }
    }

    let cardForRow = <div><b>Card For:</b> {cardFor}</div>;
    if (selectedOrder && (
        selectedOrder.product_type === 'Forms' ||
        selectedOrder.product_type === 'Apparel' ||
        selectedOrder.product_type === 'Promotional' ||
        selectedOrder.product_type === 'MyUTHealth' ||
        selectedOrder.product_type === 'Brochures & Flyers' ||
        selectedOrder.product_type === 'NRC'
    )) {
        cardForRow = null;
    }

    let printingOptionRow = null;
    let languageRow = null;
    if (selectedOrder && selectedOrder.product_type === 'Forms') {
        let variables = JSON.parse(selectedOrder.variables);
        if (variables.printingOption && variables.printingOption === 'color') {
            printingOptionRow = <div><b>Printing Option:</b> Color</div>;
        } else if (variables.printingOption && variables.printingOption === 'bw') {
            printingOptionRow = <div><b>Printing Option:</b> Black &amp; White</div>;
        }

        if (variables.language) {
            languageRow = <div><b>Language:</b> {variables.language}</div>;
        }
    }

    const renderApparelDetails = (persons, color, variablesJson) => {
        if (persons == null) {
            return null;
        }

        return persons.map((person, index1) => {
            return person.items.map((item, index2) => {
                let logoColumn = null;
                let logoImgColumn = null;
                if (person.logo !== undefined) {
                    let logoName = '';
                    if (parseInt(person.logo) === 1) {
                        logoName = 'UT Physicians';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/utp-logo-140524.png" alt="UT Physicians" /></td>;
                    } else if (parseInt(person.logo) === 2) {
                        if (person.isUthHouston !== undefined && person.isUthHouston != null && parseInt(person.isUthHouston) === 1) {
                            logoName = 'Heart and Vascular';
                            logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/uth-houston-logo-low.png" alt="UTHealth Houston" /></td>;
                        } else {
                            logoName = 'UTHealth Houston';

                            let templateCode = parseInt(variablesJson.apparelTemplateCode);
                            if ([22, 23, 24, 25, 30, 31, 32, 33, 39, 40, 44, 45, 46, 51, 52, 53, 60, 61, 63, 64, 65, 66, 67, 69, 70, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100].includes(templateCode)) {
                                logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/uth-new-logo-low.png" alt="UTHealth Houston" /></td>;
                            } else if ([102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 126].includes(templateCode)) {
                                logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-new-logo.png" alt="UTHealth Houston" /></td>;
                            }
                        }
                    } else if (parseInt(person.logo) === 4) {   // Cizik School of Nursing
                        logoName = 'Cizik School of Nursing';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-cizik.logo.png" alt="Cizik School of Nursing" /></td>;
                    } else if (parseInt(person.logo) === 5) {   // McGovern Medical School
                        logoName = 'McGovern Medical School';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-mcgovern-logo.png" alt="McGovern Medical School" /></td>;
                    } else if (parseInt(person.logo) === 6) {   // School of Biomedical Informatics
                        logoName = 'School of Biomedical Informatics';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-biomedical-informatics-logo.png" alt="School of Biomedical Informatics" /></td>;
                    } else if (parseInt(person.logo) === 7) {   // School of Dentistry
                        logoName = 'School of Dentistry';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-dentistry-logo.png" alt="School of Dentistry" /></td>;
                    } else if (parseInt(person.logo) === 8) {   // School of Public Health
                        logoName = 'School of Public Health';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-public-health-logo.png" alt="School of Public Health" /></td>;
                    } else if (parseInt(person.logo) === 9) {   // UTHealth Houston General
                        logoName = 'UTHealth Houston General';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-general-logo.png" alt="UTHealth Houston General" /></td>;
                    } else if (parseInt(person.logo) === 10) {   // School of Public Health - Austin
                        logoName = 'School of Public Health - Austin';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-austin.png" alt="School of Public Health - Austin" /></td>;
                    } else if (parseInt(person.logo) === 11) {   // School of Public Health - Brownsville
                        logoName = 'School of Public Health - Brownsville';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-brownsville.png" alt="School of Public Health - Brownsville" /></td>;
                    } else if (parseInt(person.logo) === 12) {   // School of Public Health - Dallas
                        logoName = 'School of Public Health - Dallas';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-dallas.png" alt="School of Public Health - Dallas" /></td>;
                    } else if (parseInt(person.logo) === 13) {   // School of Public Health - El Paso
                        logoName = 'School of Public Health - El Paso';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-el-paso.png" alt="School of Public Health - El Paso" /></td>;
                    } else if (parseInt(person.logo) === 14) {   // School of Public Health - San Antonio
                        logoName = 'School of Public Health - San Antonio';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-san-antonio.png" alt="School of Public Health - San Antonio" /></td>;
                    } else if (parseInt(person.logo) === 15) {   // UTHealth Houston Children's Heart Institute
                        logoName = 'UTHealth Houston Children\'s Heart Institute';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-childrens-heart.png" alt="UTHealth Houston Children's Heart Institute" /></td>;
                    } else if (parseInt(person.logo) === 16) {   // McWilliams School of Biomedical Informatics
                        logoName = 'McWilliams School of Biomedical Informatics';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/mcwilliams-logo-v82923.png" alt="McWilliams School of Biomedical Informatics" /></td>;
                    } else if (parseInt(person.logo) === 17) {   // UTHealth Houston Neurosciences
                        logoName = 'UTHealth Houston Neurosciences';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/UTHH-Neuroscience.png" alt="UTHealth Houston Neurosciences" /></td>;
                    } else if (parseInt(person.logo) === 18) {   // UTHealth Houston Cizik Eye Clinic
                        logoName = 'UTHealth Houston Cizik Eye Clinic';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/UTHH-RobertCizikEyeClinic.png" alt="UTHealth Houston Cizik Eye Clinic" /></td>;
                    }

                    logoColumn = <td>{logoName}</td>;
                }

                let sizeName = '';
                if (item.size === 'XS') {
                    sizeName = 'Extra Small';
                } else if (item.size === 'SM') {
                    sizeName = 'Small';
                } else if (item.size === 'MD') {
                    sizeName = 'Medium';
                } else if (item.size === 'LG') {
                    sizeName = 'Large';
                } else if (item.size === 'XL') {
                    sizeName = 'Extra Large';
                } else if (item.size === '2XL') {
                    sizeName = '2XL';
                } else if (item.size === '3XL') {
                    sizeName = '3XL';
                } else if (item.size === '4XL') {
                    sizeName = '4XL';
                } else if (item.size === '5XL') {
                    sizeName = '5XL';
                } else if (item.size === '6XL') {
                    sizeName = '6XL';
                } else if (item.size === '7XL') {
                    sizeName = '7XL';
                } else if (item.size === '8XL') {
                    sizeName = '8XL';
                }

                let embroideryColumn = null;
                if (person.embroideryFirstLine !== undefined) {
                    embroideryColumn = (
                        <td>
                            <div><b>1st Line:</b> {person.embroideryFirstLine}</div>
                            <div><b>2nd Line:</b> {person.embroiderySecondLine}</div>
                            <div><b>Email:</b> {person.embroideryEmail}</div>
                        </td>
                    );
                }

                let uthIdColumn = null;
                let name = person.name;
                if (person.lastName) {
                    let personNameParts = [person.name];
                    if (person.middleName !== '') {
                        personNameParts.push(person.middleName);
                    }
                    if (person['lastName'] !== '') {
                        personNameParts.push(person.lastName);
                    }
                    name = personNameParts.join(' ');

                    uthIdColumn = <td>{person.uthId}</td>;
                }

                return (
                    <tr key={index1 + '-' + index2}>
                        <td>{item.sku}</td>
                        <td>{name}</td>
                        {uthIdColumn}
                        {embroideryColumn}
                        {logoColumn}
                        {logoImgColumn}
                        <td>{sizeName}</td>
                        <td>{color}</td>
                        <td className="text-center">{numeral(item.unit_price).format('$0,0.00')}</td>
                        <td className="text-center">{numeral(item.quantity).format('0,0')}</td>
                        <td className="text-center">{numeral(item.total_price).format('$0,0.00')}</td>
                    </tr>
                );
            });
        });
    };

    let apparelTable = null;
    let managerInformationContanier = null;
    let skuRow = <div><b>SKU:</b> {selectedOrder ? selectedOrder.sku : ''}</div>;
    let unitPriceRow = <div><b>Unit Price:</b> {selectedOrder ? numeral(selectedOrder.unit_price).format('$0,0.00[0]') : null}</div>;
    if (selectedOrder && selectedOrder.product_type === 'Apparel') {
        let persons = null;
        let hasLogo = false;
        let hasEmbroidery = false;
        let isManager = false;
        if (selectedOrder['variables'] && selectedOrder['variables'] !== '') {
            let variablesJson = JSON.parse(selectedOrder['variables']);

            if (parseInt(variablesJson['apparelTemplateCode']) === 125) {
                const imagePositions = [];
                if (parseInt(variablesJson.uth_unisex_position_full_front) === 1) {
                    imagePositions.push(<li>Full Front (image size: 12" w x 16" h)</li>);
                }
                if (parseInt(variablesJson.uth_unisex_position_full_back) === 1) {
                    imagePositions.push(<li>Full Back (image size: 12" w x 16" h)</li>);
                }
                if (parseInt(variablesJson.uth_unisex_position_left_chest) === 1) {
                    imagePositions.push(<li>Left Chest (image size: 4" w x 2" h)</li>);
                }
                if (parseInt(variablesJson.uth_unisex_position_right_chest) === 1) {
                    imagePositions.push(<li>Right Chest (image size: 4" w x 2" h)</li>);
                }
                if (parseInt(variablesJson.uth_unisex_position_sleeve) === 1) {
                    imagePositions.push(<li>Sleeve (image size: 2" w x 1" h)</li>);
                }
                if (parseInt(variablesJson.uth_unisex_position_other) === 1) {
                    imagePositions.push(<li>Other area ({variablesJson.uth_unisex_position_other_text})</li>);
                }

                const inks = [];
                if (parseInt(variablesJson.uth_unisex_ink_university_orange) === 1) {
                    inks.push(<li>University Orange (PMS 167U)</li>);
                }
                if (parseInt(variablesJson.uth_unisex_ink_university_blue) === 1) {
                    inks.push(<li>University Blue (PMS 5405U)</li>);
                }
                if (parseInt(variablesJson.uth_unisex_ink_university_grey) === 1) {
                    inks.push(<li>University Gray (Cool Gray 11U)</li>);
                }
                if (parseInt(variablesJson.uth_unisex_ink_university_black_white) === 1) {
                    inks.push(<li>University Black &amp; White</li>);
                }
                if (parseInt(variablesJson.uth_unisex_ink_gulf_blue) === 1) {
                    inks.push(<li>Gulf Blue (PMS 295U)</li>);
                }
                if (parseInt(variablesJson.uth_unisex_ink_mustard) === 1) {
                    inks.push(<li>Mustard (PMS 7406U)</li>);
                }
                if (parseInt(variablesJson.uth_unisex_ink_dark_sage) === 1) {
                    inks.push(<li>Dark Sage (PMS 555U)</li>);
                }
                if (parseInt(variablesJson.uth_unisex_ink_dusty_lavender) === 1) {
                    inks.push(<li>Dusty Lavender (PMS 668U)</li>);
                }

                let shirtColor = [];
                if (parseInt(variablesJson.uth_unisex_shirt_color) === 1) {
                    shirtColor.push(<li>White 100% cotton</li>);
                } else if (parseInt(variablesJson.uth_unisex_shirt_color) === 2) {
                    shirtColor.push(<li>Black 100% cotton</li>);
                } else if (parseInt(variablesJson.uth_unisex_shirt_color) === 3) {
                    shirtColor.push(<li>Navy 100% cotton</li>);
                } else if (parseInt(variablesJson.uth_unisex_shirt_color) === 4) {
                    shirtColor.push(<li>Texas Orange 100% cotton</li>);
                }

                const sizes = [];
                if (parseInt(variablesJson.uth_unisex_size_small) === 1) {
                    sizes.push(<li>Small (Qty: {variablesJson.uth_unisex_size_small_qty})</li>);
                }
                if (parseInt(variablesJson.uth_unisex_size_medium) === 1) {
                    sizes.push(<li>Medium (Qty: {variablesJson.uth_unisex_size_medium_qty})</li>);
                }
                if (parseInt(variablesJson.uth_unisex_size_large) === 1) {
                    sizes.push(<li>Large (Qty: {variablesJson.uth_unisex_size_large_qty})</li>);
                }
                if (parseInt(variablesJson.uth_unisex_size_xl) === 1) {
                    sizes.push(<li>X-Large (Qty: {variablesJson.uth_unisex_size_xl_qty})</li>);
                }
                if (parseInt(variablesJson.uth_unisex_size_2xl) === 1) {
                    sizes.push(<li>2XL (Qty: {variablesJson.uth_unisex_size_2xl_qty})</li>);
                }
                if (parseInt(variablesJson.uth_unisex_size_3xl) === 1) {
                    sizes.push(<li>3XL (Qty: {variablesJson.uth_unisex_size_3xl_qty})</li>);
                }

                let filesContainer = null;
                if (variablesJson.uth_unisex_files.length > 0) {
                    const files = [];
                    for (let i = 0; i < variablesJson.uth_unisex_files.length; i++) {
                        const file = variablesJson.uth_unisex_files[i];
                        files.push(<li><a href={file.url} target="_blank" rel="noopener noreferrer">{file.name}</a></li>);
                    }
                    filesContainer = (
                        <Fragment>
                            <div><b>Files:</b></div>
                            <ul className="sizes-list">
                                {files}
                            </ul>
                        </Fragment>
                    );
                }

                apparelTable = (
                    <div className="apparel-table">
                        <b>Details:</b>
                        <div><b>Image Position:</b></div>
                        <ul className="image-positions-list">
                            {imagePositions}
                        </ul>
                        <div><b>Ink:</b></div>
                        <ul className="inks-list">
                            {inks}
                        </ul>
                        <div><b>Shirt Color:</b></div>
                        <ul className="inks-list">
                            {shirtColor}
                        </ul>
                        <div><b>Sizes:</b></div>
                        <ul className="sizes-list">
                            {sizes}
                        </ul>
                        {filesContainer}
                    </div>
                );
            } else {
                persons = variablesJson.personsParsed;

                if (persons) {
                    unitPriceRow = null;
                    pdfUrlRow = null;
                    skuRow = null;

                    if (persons[0].logo !== undefined) {
                        hasLogo = true;
                    }

                    if (persons[0].embroideryFirstLine !== undefined) {
                        hasEmbroidery = true;
                    }

                    if (persons[0].lastName !== undefined) {
                        isManager = true;
                    }

                    apparelTable = (
                        <div className="apparel-table">
                            <b>Details:</b>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>SKU</th>
                                        <th>Name</th>
                                        {isManager ? <th>UTH-ID#</th> : null}
                                        {hasEmbroidery ? <th>Embroidery</th> : null}
                                        {hasLogo ? <th>Logo</th> : null}
                                        {hasLogo ? <th>Logo Image</th> : null}
                                        <th>Size</th>
                                        <th>Color</th>
                                        <th className="text-center">Unit Price</th>
                                        <th className="text-center">Qty</th>
                                        <th className="text-center">Total Price</th>
                                    </tr>
                                </thead>
                                <tbody>{renderApparelDetails(persons, variablesJson.color, variablesJson)}</tbody>
                            </table>
                        </div>
                    );
                }

                if (variablesJson.managerName !== undefined) {
                    managerInformationContanier = (
                        <Fragment>
                            <div><b>Manager Clinic Name:</b> {variablesJson.managerClinicName}</div>
                            <div><b>Manager Manager Name:</b> {variablesJson.managerName}</div>
                            <div><b>Manager Email:</b> {variablesJson.managerEmail}</div>
                            <div><b>Manager Address:</b> {variablesJson.managerAddress}</div>
                            <div><b>Manager City:</b> {variablesJson.managerCity}</div>
                            <div><b>Manager State:</b> {variablesJson.managerState}</div>
                            <div><b>Manager Zip:</b> {variablesJson.managerZip}</div>
                            <div><b>Manager Direct Phone Line:</b> {variablesJson.managerPhone}</div>
                        </Fragment>
                    );
                }
            }
        }
    }

    let stockRow = null;
    if (selectedOrder && selectedOrder.product_type === 'Cards') {
        let json = JSON.parse(selectedOrder.variables);
        if (json.stock && json.stock != null && json.stock !== '') {
            if (parseInt(json.stock) === 1) {
                stockRow = <div><b>Stock:</b> Good</div>;
            } else if (parseInt(json.stock) === 2) {
                stockRow = <div><b>Stock:</b> Better</div>;
            } else if (parseInt(json.stock) === 3) {
                stockRow = <div><b>Stock:</b> Best</div>;
            }
        }
    }

    let schedulingLocationRow = null;
    if (selectedOrder && selectedOrder.product_type === 'Cards') {
        let json = JSON.parse(selectedOrder.variables);
        if (json.schedulingCard && json.schedulingCard != null && json.schedulingCard !== '') {
            if (parseInt(json.schedulingCard) === 1) {
                schedulingLocationRow = <div><b>Location:</b> The Woodlands</div>;
            } else if (parseInt(json.schedulingCard) === 2) {
                schedulingLocationRow = <div><b>Location:</b> Texas Medical Center</div>;
            } else if (parseInt(json.schedulingCard) === 3) {
                schedulingLocationRow = <div><b>Location:</b> Facial Plastic Surgery</div>;
            } else if (parseInt(json.schedulingCard) === 4) {
                schedulingLocationRow = <div><b>Location:</b> Pediatric ENT</div>;
            } else if (parseInt(json.schedulingCard) === 5) {
                schedulingLocationRow = <div><b>Location:</b> Greater Heights</div>;
            } else if (parseInt(json.schedulingCard) === 6) {
                schedulingLocationRow = <div><b>Location:</b> Southeast Houston</div>;
            }
        }
    }

    const exportPdf = () => {
        props.exportOrder(selectedOrder.id, selectedOrder.uthealth_order_id);
    };

    let exportButtonLabel = 'Export PDF';
    if (props.exportingOrder) {
        exportButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }

    let customerPickupRow = null;
    if (selectedOrder && parseInt(selectedOrder.user_id) !== 187 && parseInt(selectedOrder.order_type_id) === 1 && parseInt(selectedOrder.shipping_price) === 0 && parseInt(selectedOrder.order_shipping_price) === 0) {
        customerPickupRow = <div className="customer-pickup-row"><b>Shipping Type:</b> Customer Pickup</div>;
    }

    let shippingPriceValue = selectedOrder ? numeral(selectedOrder.shipping_price).format('$0,0.00') : null;
    if (selectedOrder && selectedOrder.order_shipping_price && selectedOrder.order_shipping_price > 0) {
        shippingPriceValue = numeral(selectedOrder.order_shipping_price).format('$0,0.00') + ' (One charge per the whole order)';
    }

    let penClinicNameRow = null;
    let penPhoneRow = null;
    let penInkRow = null;
    let penNotesRow = null;
    if (selectedOrder && selectedOrder.product_type === 'Promotional') {
        const variables = JSON.parse(selectedOrder.variables);
        if (parseInt(variables.promotionalTemplateCode) === 20) {
            pdfUrlRow = null;

            let clinicName = 'None';
            if (variables.clinicName && variables.clinicName !== '') {
                clinicName = variables.clinicName;
            }

            let phone = 'None';
            if (variables.phone && variables.phone !== '') {
                phone = variables.phone;
            }

            penClinicNameRow = <div><b>Line 2 (Clinic Name):</b> {clinicName}</div>;
            penPhoneRow = <div><b>Line 3 (Phone):</b> {phone}</div>;
            penInkRow = <div><b>Ink:</b> {variables.ink}</div>;
            penNotesRow = <div><b>Notes:</b> {variables.notes}</div>;
        }
    }

    let clinicNameRow = null;
    let locationRow = null;
    let notesRow = null;
    if (selectedOrder && selectedOrder.product_type === 'MyUTHealth') {
        const variables = JSON.parse(selectedOrder.variables);
        if (parseInt(variables['myuthealthTemplateCode']) !== 9) {
            languageRow = <div><b>Language:</b> {variables['language']}</div>;
        }

        if (variables['clinic'] !== '') {
            clinicNameRow = <div><b>Clinic Name:</b> {variables['clinic']}</div>;
        } else {
            clinicNameRow = <div><b>Clinic Name:</b> {variables['clinicName']}</div>;
        }

        if (variables['location'] !== '') {
            locationRow = <div><b>Location:</b> {variables['location']}</div>;
        } else {
            locationRow = <div><b>Location:</b> {variables['yourLocation']}</div>;
        }

        if (variables['notes'] !== '') {
            notesRow = <div><b>Notes:</b> {variables['notes']}</div>;
        }

        if (parseInt(variables['myuthealthTemplateCode']) === 10) {
            languageRow = null;
            clinicNameRow = null;
            locationRow = null;
            notesRow = null;
        }
    }

    if (selectedOrder && selectedOrder.product_type === 'Brochures & Flyers') {
        const variables = JSON.parse(selectedOrder.variables);
        if (variables['notes'] !== '') {
            notesRow = <div><b>Notes:</b> {variables['notes']}</div>;
        }
    }

    if (selectedOrder && selectedOrder.product_type === 'Notepads') {
        const variables = JSON.parse(selectedOrder.variables);
        notesRow = <div><b>Notes:</b> {variables['notes']}</div>;
    }

    let imageRow = null;
    if (selectedOrder && selectedOrder.product_type === 'NRC') {
        const variables = JSON.parse(selectedOrder.variables);
        imageRow = <div><b>Image:</b> {variables['image']}</div>;

        if (variables['notes'] !== '') {
            notesRow = <div><b>Notes:</b> {variables['notes']}</div>;
        }
    }

    let materialTypeRow = null;
    let orientationRow = null;
    let sizeRow = null;
    if (selectedOrder && selectedOrder.product_type === 'Forms') {
        const variables = JSON.parse(selectedOrder.variables);
        if (parseInt(variables['staticTemplateCode']) === 473) {
            languageRow = <div><b>Language:</b> {variables['language']}</div>;
            materialTypeRow = <div><b>Material Type:</b> {variables['materialType']}</div>;
            orientationRow = <div><b>Orientation:</b> {variables['orientation']}</div>;
            sizeRow = <div><b>Size:</b> {variables['size']}</div>;
        } else if (parseInt(variables['staticTemplateCode']) === 647) {
            languageRow = <div><b>Language:</b> {variables['language']}</div>;
            materialTypeRow = <div><b>Type:</b> {variables['type']}</div>;
        }
    }

    let dateName = 'Date';
    let approvedDate = null;
    if (selectedOrder && parseInt(selectedOrder.status) === 2) {
        dateName = 'Ordered Date';
        approvedDate = <div><b>Approved Date:</b> {selectedOrder ? dateToTimezone(selectedOrder.approved_date, 'MM/DD/YYYY') : ''}</div>
    }

    let trackingNumberRow = null;
    let shippedRow = null;
    let shippingMethodRow = null;
    if (selectedOrder && parseInt(selectedOrder.status) === 2) {
        trackingNumberRow = <div><b>Tracking Number:</b> {selectedOrder.tracking_number ? selectedOrder.tracking_number : 'N/A'}</div>
        shippedRow = <div><b>Shipped:</b> {selectedOrder.shipped ? 'Yes' : 'No'}</div>
        shippingMethodRow = <div><b>Shipping Method:</b> {selectedOrder.shipping_method ? selectedOrder.shipping_method : 'N/A'}</div>
    }

    if (selectedOrder && ['Cards', 'Forms', 'Notepads', 'Brochures & Flyers', 'Stationery Letterheads',
        'Stationery Envelopes', 'Notecards', 'Pocket Folders'].includes(selectedOrder.product_type)) {
        sizeRow = <div><b>Size:</b> {selectedOrder.product_size}</div>
    }

    let platform = selectedOrder ? selectedOrder.platform : '';
    if (platform == null || platform === '' || platform === 'null') {
        platform = 'N/A';
    }

    let frontRow = null;
    if (selectedOrder && ['Cards', 'Stationery Letterheads', 'Stationery Envelopes', 'Notecards', 'Pocket Cards'].includes(selectedOrder.product_type)) {
        const variables = JSON.parse(selectedOrder.variables);

        let frontColor = 'N/A';
        if (variables.front && parseInt(variables.front) === 1) {
            frontColor = 'White';
        } else if (variables.front && parseInt(variables.front) === 2) {
            frontColor = 'Gray';
        } else if (variables.front && parseInt(variables.front) === 3) {
            frontColor = 'Orange';
        } else if (variables.front && parseInt(variables.front) === 4) {
            frontColor = 'Gulf Blue';
        }

        frontRow = <div><b>Front Color:</b> {frontColor}</div>
    }

    let additionalPdfUrlRow = null;
    if (selectedOrder && !empty(selectedOrder.additional_pdf_url)) {
        additionalPdfUrlRow = (
            <div>
                <b>Envelope PDF URL:</b> <a href={selectedOrder.additional_pdf_url} target="_blank" rel="noopener noreferrer">{selectedOrder.additional_pdf_url}</a>
            </div>
        );
    }

    let windowRow = null;
    if (selectedOrder) {
        let variables = JSON.parse(selectedOrder.variables);
        
        if (variables.window) {
            windowRow = <div className="window-row"><b>Window Envelope:</b> {parseInt(variables.window) ? 'Yes' : 'No'}</div>;
        }
        if (variables['templateCode'] === 'p3t6') {     // Co-branded No. 10 Window Envelope
            windowRow = <div className="window-row"><b>Window Envelope:</b> Yes</div>;
        }
        if (variables['templateCode'] === 'p22t1' || variables['templateCode'] === 'p22t2' || variables['templateCode'] === 'p22t3') {
            if (variables.language) {
                languageRow = <div><b>Language:</b> {variables.language}</div>;
            }
            if (variables.clinicName) {
                clinicNameRow = <div><b>Clinic Name:</b> {variables.clinicName}</div>;
            }
        }
    }

    let paperRow = null;
    if (selectedOrder && selectedOrder.product_type === 'Forms') {
        const variables = JSON.parse(selectedOrder.variables);
        if (parseInt(variables['staticTemplateCode']) === 647) {
            sizeRow = null;
        } else if (parseInt(variables['staticTemplateCode']) === 649) {
            paperRow = <div><b>Paper:</b> {variables['type']}</div>;
        } else if (parseInt(variables['staticTemplateCode']) === 651) {
            materialTypeRow = <div><b>Result:</b> {variables['type']}</div>;
        }
    }

    let logoRow = null;
    if (selectedOrder && selectedOrder.product_type === 'Promotional') {
        const variables = JSON.parse(selectedOrder.variables);
        if (parseInt(variables.logo) === 1) {
            logoRow = <div><b>Logo:</b> UT Physicians</div>;
        } else if (parseInt(variables.logo) === 2) {
            logoRow = <div><b>Logo:</b> UTHealth Houston</div>;
        } else if (parseInt(variables.logo) === 3) {
            logoRow = <div><b>Logo:</b> Heart and Vascular</div>;
        } else if (parseInt(variables.logo) === 4) {
            logoRow = <div><b>Logo:</b> Cizik School of Nursing</div>;
        } else if (parseInt(variables.logo) === 5) {
            logoRow = <div><b>Logo:</b> McGovern Medical School</div>;
        } else if (parseInt(variables.logo) === 6) {
            logoRow = <div><b>Logo:</b> School of Biomedical Informatics</div>;
        } else if (parseInt(variables.logo) === 7) {
            logoRow = <div><b>Logo:</b> School of Dentistry</div>;
        } else if (parseInt(variables.logo) === 8) {
            logoRow = <div><b>Logo:</b> School of Public Health</div>;
        } else if (parseInt(variables.logo) === 9) {
            // logoRow = <div><b>Logo:</b> UTHealth Houston General</div>;
        } else if (parseInt(variables.logo) === 10) {
            logoRow = <div><b>Logo:</b> School of Public Health - Austin</div>;
        } else if (parseInt(variables.logo) === 11) {
            logoRow = <div><b>Logo:</b> School of Public Health - Brownsville</div>;
        } else if (parseInt(variables.logo) === 12) {
            logoRow = <div><b>Logo:</b> School of Public Health - Dallas</div>;
        } else if (parseInt(variables.logo) === 13) {
            logoRow = <div><b>Logo:</b> School of Public Health - El Paso</div>;
        } else if (parseInt(variables.logo) === 14) {
            logoRow = <div><b>Logo:</b> School of Public Health - San Antonio</div>;
        } else if (parseInt(variables.logo) === 16) {
            logoRow = <div><b>Logo:</b> McWilliams School of Biomedical Informatics</div>;
        } else if (parseInt(variables.logo) === 15) {
            logoRow = <div><b>Logo:</b> UTHealth Houston Children\'s Heart Institute</div>;
        }
    }

    let actions = [
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Close</button>
    ];

    if (props.user && [3, 7].includes(parseInt(props.user.uth_type))) {
        actions.push(<button key="cancel-button" className="btn btn-light btn-sm action-button" onClick={exportPdf} disabled={props.exportingOrder}>{exportButtonLabel}</button>)
    }

    return (
        <Dialog
            name="info-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 1000 }}
            bodyStyle={{ overflow: 'initial' }}
            className="info-dialog"
        >
            <div className="info-container">
                <div className="order-information">
                    <div className="title">Order Information</div>
                    <div><b>ID:</b> {selectedOrder ? selectedOrder.uthealth_order_id : ''}</div>
                    {quantityRow}
                    {piecesPer}
                    <div><b>Platform:</b> {platform.toUpperCase()}</div>
                    <div><b>Product Name:</b> {selectedOrder ? selectedOrder.product_name : ''}</div>
                    <div><b>Product Type:</b> {selectedOrder ? selectedOrder.product_type : null}</div>
                    {logoRow}
                    {schedulingLocationRow}
                    {frontRow}
                    {printingOptionRow}
                    {penClinicNameRow}
                    {penPhoneRow}
                    {penInkRow}
                    {penNotesRow}
                    {stockRow}
                    {languageRow}
                    {materialTypeRow}
                    {paperRow}
                    {orientationRow}
                    {sizeRow}
                    {windowRow}
                    {clinicNameRow}
                    {locationRow}
                    {imageRow}
                    {notesRow}
                    {unitPriceRow}
                    <div><b>Order Type:</b> {selectedOrder ? selectedOrder.order_type : null}</div>
                    <div><b>{dateName}:</b> {selectedOrder ? dateToTimezone(selectedOrder.created_at, 'MM/DD/YYYY') : ''}</div>
                    {approvedDate}
                    {customerPickupRow}
                    <div><b>Subtotal Price:</b> {selectedOrder ? numeral(selectedOrder.total_price - selectedOrder.shipping_price - selectedOrder.tax_price).format('$0,0.00') : null}</div>
                    <div><b>Tax:</b> {selectedOrder ? numeral(selectedOrder.tax_price).format('$0,0.00') : null}</div>
                    <div><b>Shipping Price:</b> {shippingPriceValue}</div>
                    <div><b>Total Price:</b> {selectedOrder ? numeral(selectedOrder.total_price).format('$0,0.00') : null}</div>
                    {cardForRow}
                    {skuRow}
                    <div><b>Ordered By:</b> {orderedBy}</div>
                    <div><b>Status:</b> {status}</div>
                    {actionByRow}
                    {pdfUrlRow}
                    {additionalPdfUrlRow}
                    {shippedRow}
                    {shippingMethodRow}
                    {trackingNumberRow}
                    {managerInformationContanier}
                    {apparelTable}
                </div>
                <div className="addresses-container">
                    <div className="bill">
                        <div className="title">Bill To</div>
                        <div><b>Name:</b> {selectedOrder ? selectedOrder.billName : ''}</div>
                        <div><b>Address Line 1:</b> {selectedOrder ? selectedOrder.billAddress1 : ''}</div>
                        <div><b>Address Line 2:</b> {selectedOrder ? selectedOrder.billAddress2 : ''}</div>
                        <div><b>City:</b> {selectedOrder ? selectedOrder.billCity : ''}</div>
                        <div><b>State:</b> {selectedOrder ? selectedOrder.billState : ''}</div>
                        <div><b>Zip:</b> {selectedOrder ? selectedOrder.billZip : ''}</div>
                        <div><b>Phone:</b> {selectedOrder ? selectedOrder.billPhone : ''}</div>
                        <div><b>Email:</b> {selectedOrder ? selectedOrder.billEmail : ''}</div>
                        <div><b>PO #:</b> {selectedOrder ? selectedOrder.billPo : ''}</div>
                        <div><b>Dept. Info:</b> {selectedOrder ? selectedOrder.billDepartment : ''}</div>
                        <div><b>Call for CC#:</b> {selectedOrder ? (selectedOrder.billCall ? 'Yes' : 'No') : ''}</div>
                        <div><b>Notes:</b> {selectedOrder ? selectedOrder.billNotes : ''}</div>
                    </div>
                    <div className="ship">
                        <div className="title">Ship To</div>
                        <div><b>Name:</b> {selectedOrder ? selectedOrder.shipName : ''}</div>
                        <div><b>Address Line 1:</b> {selectedOrder ? selectedOrder.shipAddress1 : ''}</div>
                        <div><b>Address Line 2:</b> {selectedOrder ? selectedOrder.shipAddress2 : ''}</div>
                        <div><b>City:</b> {selectedOrder ? selectedOrder.shipCity : ''}</div>
                        <div><b>State:</b> {selectedOrder ? selectedOrder.shipState : ''}</div>
                        <div><b>Zip:</b> {selectedOrder ? selectedOrder.shipZip : ''}</div>
                        <div><b>Phone:</b> {selectedOrder ? selectedOrder.shipPhone : ''}</div>
                        <div><b>Email:</b> {selectedOrder ? selectedOrder.shipEmail : ''}</div>
                        <div><b>Notes:</b> {selectedOrder ? selectedOrder.shipNotes : ''}</div>
                    </div>
                </div>
            </div>
        </Dialog >
    );
});

export default InfoModal;
